import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LpClickOutsideDirective } from './lp-click-outside.directive';

@NgModule({
  declarations: [	
      LpClickOutsideDirective
   ],
  imports: [
    CommonModule
  ],
  exports: [LpClickOutsideDirective]
})
export class LpClickOutsideModule { }
